module.exports = __webpack_public_path__ + "img/horizontal_6_7_pp12_7042.2561f7c9.png";